const ENDPOINTS = {
  AUTH: {
    REGISTER: "/auth/register",
    LOGIN: "/auth/login",
    REFRESH: "/auth/refresh",
    LOGOUT: "/auth/logout",
    VERIFY_EMAIL: "/auth/verify-email",
    RESEND_VERIFICATION: "/auth/resend-verification",
    FORGOT_PASSWORD: "/auth/forgot-password",
    RESET_PASSWORD: "/auth/reset-password",
    RESET_PASSWORD_PAGE: "/auth/reset-password-page",
  },

  USERS: {
    ME: "/users/me",
    ALL: "/users",
    BY_ID: (id) => `/users/${id}`,
    DELETE: (id) => `/users/${id}`,
    BY_ROLE: (role) => `/users/role/${role}`,
    BOOKINGS: (id) => `/users/${id}/bookings`,
  },

  SERVICES: {
    ALL: "/services",
    BY_ID: (id) => `/services/${id}`,
    BY_NAME: "/services/by-name",
    TYPES: "/services/types",
    CREATE: "/services",
    UPDATE: (id) => `/services/${id}`,
    DELETE: (id) => `/services/${id}`,
    WITH_BOOKINGS: (id) => `/services/with-bookings/${id}`,
    WITH_BOOKINGS_BY_NAME: "/services/with-bookings/by-name",
  },

  BOOKINGS: {
    USER: "/bookings/user",
    GUEST: "/bookings/guest",
    BY_ID: (id) => `/bookings/${id}`,
    BY_USER_ID: (userId) => `/bookings/user/${userId}`,
    BY_CONFIRMATION: (code) => `/bookings/confirmation/${code}`,
    ALL: "/bookings/all-bookings",
    BY_DATE: (date) => `/bookings/date/${date}`,
    BY_STATUS: (status) => `/bookings/status/${status}`,
    CANCEL_BY_ID: (id) => `/bookings/${id}/cancel`,
    CANCEL_BY_CONFIRMATION: (code) => `/bookings/confirmation/${code}/cancel`,
    COMPLETE: (id) => `/bookings/${id}/complete`,
  },

  AVAILABILITY: {
    ALL: "/availabilities",
    BY_ID: (id) => `/availabilities/${id}`,
    BY_DATE: (date) => `/availabilities/date/${date}`,
    BETWEEN: "/availabilities/between",
    VALIDATE: "/availabilities/validate",
    CREATE: "/availabilities",
    UPDATE: (id) => `/availabilities/${id}`,
    DELETE: (id) => `/availabilities/${id}`,
  },

  CONTACT: {
    SEND: "/contact",
  },

  FILES: {
    UPLOAD: "/files/upload",
    UPLOAD_BY_CATEGORY: (category) => `/files/upload/${category}`,
    VIEW: (fileName) => `/files/${fileName}`,
    VIEW_BY_CATEGORY: (category, fileName) => `/files/${category}/${fileName}`,
  },
};

export default ENDPOINTS;